// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Users_tabsContainer__k2mzT","tab":"Users_tab__cTCwK","tabActive":"Users_tabActive__WY-el","userCounter":"Users_userCounter__v1CcR"};